import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {Platform} from '@ionic/angular';
import {PatientDataProvider} from '../../../providers/patient-data/patient-data';
import {PatientAlertProvider} from '../../../providers/patient-alert/patient-alert';
import {Events} from '../../../providers/events';
import {ViewController} from '../../../providers/view-controller.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-page-modal-patient-tabs',
  templateUrl: 'modal-patient-tabs.html',
  styleUrls: ['./modal-patient-tabs.scss']
})
export class ModalPatientTabsPageComponent implements OnInit, OnDestroy {
  @Input() showPatient: boolean;
  isCore = true;
  private closePatientModal: Subscription;

  constructor(public patientDataProvider: PatientDataProvider,
              public patientAlertProvider: PatientAlertProvider,
              private plf: Platform, private events: Events, private viewCtrl: ViewController) {
  }

  ngOnInit() {
    this.isCore = this.plf.is('desktop'); // TODOALEX

    this.closePatientModal = this.events.subscribe('closePatientModal', () => {
      this.dismiss();
    });
  }

  ngOnDestroy() {
    this.closePatientModal.unsubscribe();
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }

}
